import React from 'react';
import styles from './explore-results-diversity-timetable.module.sass';
import { Typography, Tooltip, Popover, Divider } from 'antd';
import _, { indexOf } from 'lodash';

function ExploreResultsDiversityTimetable({
  data,
  status,
  epochLowest,
  epochHighest,
  timeUnitInPixels,
}) {
  const { Title, Text, Paragraph } = Typography;

  const calcIpDiversityBg = function (timelineElement) {
    const indexOfElement = Object.keys(
      _.groupBy(data?.response?.records?.[0]?.timeline, 'asn'),
    ).indexOf(timelineElement);

    if (indexOfElement === 0) {
      return 'rgba(51, 188, 183, 0.32)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 0) {
      return 'rgba(51, 188, 183, 0.32)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 1) {
      return 'rgba(232, 71, 73, 0.32)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 2) {
      return 'rgba(232, 214, 57, 0.32)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 3) {
      return 'rgba(82, 115, 224, 0.32)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 4) {
      return 'rgba(232, 112, 64, 0.32)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 5) {
      return 'rgba(232, 214, 57, 0.32)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 6) {
      return 'rgba(224, 82, 156, 0.32)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 7) {
      return 'rgba(89, 89, 89, 0.32)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 8) {
      return 'rgba(106, 190, 57, 0.32)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 9) {
      return 'rgba(60, 154, 232, 0.32)';
    } else {
      return 'rgba(232, 112, 64, 0.32)';
    }
  };

  const calcIpDiversityBarBg = function (timelineElement) {
    const indexOfElement = Object.keys(
      _.groupBy(data?.response?.records?.[0]?.timeline, 'asn'),
    ).indexOf(timelineElement);

    if (indexOfElement === 0) {
      return 'rgba(232, 71, 73, 1)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 0) {
      return 'rgba(232, 71, 73, 1)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 1) {
      return 'rgba(232, 112, 64, 1)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 2) {
      return 'rgba(232, 154, 60, 1)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 3) {
      return 'rgba(232, 179, 57, 1)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 4) {
      return 'rgba(232, 214, 57, 1)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 5) {
      return 'rgba(169, 209, 52, 1)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 6) {
      return 'rgba(106, 190, 57, 1)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 7) {
      return 'rgba(51, 188, 183, 1)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 8) {
      return 'rgba(60, 154, 232, 1)';
    } else if (indexOfElement > 0 && indexOfElement % 10 === 9) {
      return 'rgba(82, 115, 224, 1)';
    } else {
      return 'rgba(232, 112, 64, 1)';
    }
  };

  return (
    <div className={styles.explore_results_diversity_timetable}>
      <Title level={4}>IP Diversity Timetable</Title>

      <div className={styles.top_labels}>
        <Text>AS Name</Text>
        <Text>ASN</Text>
        <Text>IP</Text>
      </div>

      {data?.response?.records?.[0]?.timeline?.map((timelineElement) => {
        const leftPercentage =
          Math.floor(
            (new Date(timelineElement?.first_seen)?.getTime() / 1000 -
              epochLowest) /
              timeUnitInPixels /
              5.8,
          ) >= 100
            ? 100
            : Math.floor(
                (new Date(timelineElement?.first_seen)?.getTime() / 1000 -
                  epochLowest) /
                  timeUnitInPixels /
                  5.8,
              );
        const widthPercentage =
          Math.floor(
            (new Date(timelineElement?.last_seen).getTime() / 1000 -
              new Date(timelineElement?.first_seen).getTime() / 1000) /
              timeUnitInPixels /
              5.8,
          ) >= 100
            ? 100
            : Math.floor(
                (new Date(timelineElement?.last_seen).getTime() / 1000 -
                  new Date(timelineElement?.first_seen).getTime() / 1000) /
                  timeUnitInPixels /
                  5.8,
              );

        return (
          <div
            className={styles.rows}
            style={{ background: calcIpDiversityBg(timelineElement?.asn) }}
          >
            <div className={styles.row_info}>
              <Tooltip title={timelineElement?.asname}>
                <Text>
                  {timelineElement?.asname?.length > 10
                    ? timelineElement?.asname?.substr(0, 10) + '...'
                    : timelineElement?.asname}
                </Text>
              </Tooltip>
              <Text>{timelineElement?.asn}</Text>
              <Text>{timelineElement?.ip}</Text>
            </div>

            <div className={styles.row_bars_container}>
              <Popover
                placement="bottom"
                content={
                  <>
                    <Paragraph style={{ color: 'white' }}>
                      AS Number:{' '}
                      <Text strong style={{ color: 'white' }}>
                        {timelineElement?.asn}
                      </Text>
                    </Paragraph>
                    <Paragraph style={{ color: 'white' }}>
                      AS Name:{' '}
                      <Text strong style={{ color: 'white' }}>
                        {timelineElement?.asname}
                      </Text>
                    </Paragraph>
                    <Paragraph style={{ color: 'white' }}>
                      IP:{' '}
                      <Text strong style={{ color: 'white' }}>
                        {timelineElement?.ip}
                      </Text>
                    </Paragraph>
                    <Paragraph style={{ color: 'white' }}>
                      First Seen:{' '}
                      <Text strong style={{ color: 'white' }}>
                        {timelineElement?.first_seen}
                      </Text>
                    </Paragraph>
                    <Paragraph style={{ color: 'white', margin: '0' }}>
                      Last Seen:{' '}
                      <Text strong style={{ color: 'white' }}>
                        {timelineElement?.last_seen}
                      </Text>
                    </Paragraph>
                  </>
                }
              >
                <div
                  className={styles.timetable_bar}
                  style={{
                    left: leftPercentage === 0 ? 0 : `${leftPercentage}%`,
                    width:
                      widthPercentage === 0 ? '3px' : `${widthPercentage}%`,
                    background: calcIpDiversityBarBg(timelineElement?.asn),
                  }}
                ></div>
              </Popover>
            </div>
          </div>
        );
      })}

      <Divider className={styles.divider_horizontal} type="horizontal" />

      <div className={styles.bottom_labels}>
        <div className={styles.info_labels}>
          <Text className={styles.time_label}>Time</Text>
        </div>
        <div className={styles.bar_labels}>
          <span>
            {new Date(epochLowest * 1000)?.toISOString()?.split('T')?.[0]}
          </span>
          <span>
            {new Date(epochHighest * 1000)?.toISOString()?.split('T')?.[0]}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ExploreResultsDiversityTimetable;
